var _circle, _path, _path2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScissors = function SvgScissors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: props.fill,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12 8.12 12 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4 8.12 15.88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 18,
    r: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 14.8 20 20"
  })));
};
export default SvgScissors;